var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('s-button',{attrs:{"variation":"tertiary","icon-left":"help-circle","size":"large"},on:{"click":_vm.openFeedbackSurvey}},[_vm._v(" "+_vm._s(_vm.$t('survey.wasItEasyToGetHere'))+" ")])}
var staticRenderFns = []

export { render, staticRenderFns }